import React from 'react'
import "./Contact_form.css"
import { Button, Form } from 'react-bootstrap'
import Success_Modal from '../../common_component/common_modal/success_modal/Success_Modal';
import Sumbit_btn from '../../common_component/common_btn/submit_btn/Sumbit_btn';
import Location_lottie from '../../Animation/location_lottie/Location_lottie';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'

function Contact_form({ mapOnClick }) {
    const [modalShow, setModalShow] = React.useState(false);
    const [phone, setPhone] = React.useState('');

    return (
        <>
            <section className='Contact_form'>
                <div className="row me-0 ms-0">
                    {/* Google Map Embed */}
                    <div className="col-xl-7 col-md-6 col-sm-6 p-0">
                        <div className="map_holder" style={{ position: 'relative' }}>
                            <iframe
                                width="100%"
                                height="100%"
                                frameBorder="0"
                                scrolling="no"
                                marginHeight="0"
                                marginWidth="0"
                                src="https://maps.google.com/maps?q=UAE%20Al%20Shohada%20Road%2C%20AL%20Hamra%20Industrial%20Zone-FZ%2C%20RAS%20AL%20KHAIMAH%2C%20United%20Arab%20Emirates&t=m&z=2&ie=UTF8&iwloc=B&output=embed"
                                title="Google Map"
                            ></iframe>

                            <div className='map_location_lottie_holder' onClick={mapOnClick}>
                                <Location_lottie />
                            </div>


                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className="col-xl-5 col-md-6 col-sm-6" >
                        <div className="form_holder">
                            <Form>
                                <Form.Group className="mb-3" controlId="formName">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Full Name*" />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formEmail">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" placeholder="Enter Email" />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formPhone">
                                    <Form.Label>Contact Number</Form.Label>
                                    <PhoneInput
                                        country={'in'}
                                        value={phone}
                                        onChange={setPhone}
                                        inputProps={{
                                            name: 'phone',
                                            required: true,
                                            autoFocus: false
                                        }}
                                        inputStyle={{ width: '100%' }}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formMessage">
                                    <Form.Label>Message</Form.Label>
                                    <Form.Control as="textarea" rows={8} placeholder='Write your message here' />
                                </Form.Group>


                                <Sumbit_btn btnText="Send Message" onClick={() => setModalShow(true)} />
                            </Form>
                        </div>
                    </div>
                </div>



            </section>
            <Success_Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                successText="Message Send"
            />
        </>
    )
}

export default Contact_form
